<template>
  <div class="interaction">
    <el-dialog v-model="visibleDialog" :visible.sync="visibleDialog" @close="visibleDialog=false"
               :close-on-click-modal="false">
      <div class="interaction-head">下派任务</div>
      <img src="@/assets/images/index/close.png" class="modalclose" @click="visibleDialog=false" alt=""/>
      <div class="interaction-box">
        <div class="interaction-li">
          <div class="interaction-left active">选择任务级别：</div>
          <div class="interaction-right">
            <div class="evaluation-click">
              <el-radio v-model="priority" label="ETP1">普通</el-radio>
              <el-radio v-model="priority" label="ETP2">紧急</el-radio>
            </div>
          </div>
        </div>
        <div class="interaction-li">
          <div class="interaction-left active">选择下发角色：</div>
          <div class="interaction-right">
            <div class="evaluation-click">
              <el-radio v-model="roleTokenClient" v-for="ele in RoleEnums.options()" :key="ele.key" :label="ele.key">
                {{ ele.comment }}
              </el-radio>
            </div>
          </div>
        </div>
        <div class="interaction-li">
          <div class="interaction-left">任务内容：</div>
          <div class="interaction-right">
            <el-input type="textarea" :rows="2" maxlength="255" placeholder="请输入内容" v-model="label"></el-input>
          </div>
        </div>
      </div>
      <div class="bt-box">
        <div class="bt" @click="socAddTask">确认</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {addTask} from "@/api/kecang";
import {RoleEnums} from "@/api/Enums";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    eventId: {
      type: String,
      required: true
    },
    eventType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      RoleEnums,
      priority: 'ETP1',
      roleTokenClient: 'ROLE_PILOT',
      label: ''
    }
  },
  computed: {
    visibleDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
  },
  methods: {
    async socAddTask() {
      if (!this.label) {
        this.$message.warning('请填写任务内容')
        return
      }
      const res = await addTask({
        eventId: this.eventId,
        type: this.eventType,
        label: this.label,
        priority: this.priority,
        roleTokenClient: this.roleTokenClient
      })
      if (res.code === 'A00000') {
        this.$message.success('任务下发成功')
        this.visibleDialog = false
      } else {
        this.$message.error('任务下发失败')
      }
    },
  }
}
</script>

<style lang="less" scoped>

/*6666666666666666*/
.interaction-box.active {
  .makepolicy-li:before {
    background: #5CBE85 !important;
  }

  .makepolicy-head span {
    color: #5CBE85 !important;
  }

  .makepolicy-laber {
    color: #5CBE85;
    background: rgba(92, 190, 133, 0.1);
  }
}

.interaction-box.active2 {
  .makepolicy-li:before {
    background: #E9463C !important;
  }

  .makepolicy-head span {
    color: #E9463C !important;
  }

  .makepolicy-laber {
    color: #E9463C;
    background: rgba(233, 70, 60, 0.1);
  }
}

.interaction-box.active3 {
  .makepolicy-li:before {
    background: #3F7CF6 !important;
  }

  .makepolicy-head span {
    color: #3F7CF6 !important;
  }

  .makepolicy-laber {
    color: #3F7CF6;
    background: rgba(39, 105, 236, 0.1);
  }
}

.interaction-box {
  .makepolicy-head {
    font-size: 18px;
    color: #fff;

    span {
      color: #EBA967;
    }
  }

  .makepolicy-box {
    background: #393F52;
    border-radius: 8px;
    padding: 16px;
    margin-top: 12px;

    .makepolicy-h {
      opacity: 0.6;
      font-size: 16px;
    }

    .makepolicy-li:before {
      content: '';
      display: block;
      position: absolute;
      width: 6px;
      height: 6px;
      background: #EBA967;
      border-radius: 50%;
      left: 0;
      top: 8px;
    }

    .makepolicy-li {
      color: rgba(255, 255, 255, 0.87);
      font-size: 16px;
      margin-top: 12px;
      padding-left: 18px;
      position: relative;
    }
  }

  .makepolicy-laber {
    background: rgba(233, 146, 60, 0.1);
    border-radius: 4px;
    height: 32px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    color: #EBA967;
    margin-top: 16px;
  }

  padding: 24px;

  .interaction-li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 24px;

    .interaction-left {
      width: 150px;
      text-align: left;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.87);
    }

    .interaction-left.active {
      line-height: 48px;
    }

    .interaction-right {
      flex: 1;
      position: relative;

      .evaluation-click {
        line-height: 48px;
      }
    }
  }
}

.interaction-head {
  font-size: 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modalclose {
  position: absolute;
  width: 20px;
  top: 22px;
  right: 16px;
  cursor: pointer;
}

/deep/ .interaction .el-dialog__header {
  display: none;
}

/deep/ .interaction .el-dialog {
  position: absolute;
  margin-top: 0 !important;
  background: url("~@/assets/images/index/xian.png") no-repeat #262D40;
  background-size: 100% 100%;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  width: 600px;
  left: calc(50% - 300px);
  top: calc(30%);
  border-radius: 8px;
  padding-bottom: 24px;

  .el-input__inner {
    height: 48px;
    background: #262D40;
    border: 1px solid #525F89;
    border-radius: 8px;
    color: #fff;
  }

  .el-textarea__inner {
    background: #393F52;
    border-radius: 8px;
    border: none;
    padding: 10px;
    height: 168px;
    color: #fff;
    font-size: 16px;
  }

  .el-select {
    width: 100%;
  }
}

/deep/ .interaction .el-dialog__body {
  padding: 0;
  text-align: left;
  color: #fff;
}

.bt-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;

  .bt {
    border-radius: 8px;
    flex: 1;
    margin: 0;
    height: 44px;
  }

  .bt2 {
    border-radius: 8px;
    width: 258px;
    margin-right: 24px;
    height: 44px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/AddTaskDialog.vue